import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IAutoplaySettings } from "../../../core/src/server/data/IAutoplayData";
import GameModel from "../../../core/src/model/GameModel";

export default class AutoplayDataParser implements IBaseDataParser<IAutoplaySettings> {
    public check(data: any): boolean {
        return false;
    }

    public parse(data: any): IAutoplaySettings[] {
       const result: IAutoplaySettings = {
            spinPresets: data.data.gameData.autoPlayList,
            defaultSpinPreset: data.data.gameData.autoPlayDefault || 0,
            lossLimits:GameModel.gameConfig.lossLimits

       };
       return [result];
    }

}
